// extracted by css-extract-rspack-plugin
export default {"Token":"SingleSelectToken-module__Token__f1S1H","colorIndicator":"SingleSelectToken-module__colorIndicator__krSWU"};